<script setup lang="ts">
import type { TUiTypeValues } from '../../../types/api/reports'

defineProps<{ value: TUiTypeValues['text'] }>()
</script>

<template>
  <div class="truncate">
    {{ value }}
  </div>
</template>
